export const SemesterActions = {
    FETCH_SEMESTER_REQUEST: 'FETCH_SEMESTER_REQUEST',
    FETCH_SEMESTER_SUCCESS: 'FETCH_SEMESTER_SUCCESS',
    FETCH_SEMESTER_FAILURE: 'FETCH_SEMESTER_FAILURE',
    // define other action types here
};